export enum TicketStatusOptions {
  Open = 'open',
  WithAw = 'withAW',
  WithCustomer = 'withCustomer',
  Closed = 'closed',
  All = 'all',
}
